/* eslint-disable import/extensions */
import React from 'react';
import BarLoader from 'react-spinners/BarLoader';
import { loading, } from '@/helpers/index';

export default function LoadingComponent() {
  return loading.show && (
    <div id="loading" className="loading">
      <div style={loading.css}>
        <BarLoader color={loading.color} loading={loading.show} className="loading-bar rounded" size={150} />
        <div id="loading-message" className="text-center mt-2">&nbsp;</div>
      </div>
    </div>
  );
}
